import { render, staticRenderFns } from "./MessageImageV2.vue?vue&type=template&id=2c5990e4&scoped=true"
import script from "./MessageImageV2.vue?vue&type=script&lang=js"
export * from "./MessageImageV2.vue?vue&type=script&lang=js"
import style0 from "./MessageImageV2.vue?vue&type=style&index=0&id=2c5990e4&prod&lang=scss&scoped=true"
import style1 from "./MessageImageV2.vue?vue&type=style&index=1&id=2c5990e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5990e4",
  null
  
)

export default component.exports